module.exports = "../../../../platform/assets/pageMainIcon/baobiaochaxunlei6.svg";